module.exports = __webpack_public_path__ + "media/images/thumbnail_temp_pdf_black-817ea0dc.png";